export default {
  globalLayoutName: {
    company: {
      create: 'Stickyweb Bedrijf aanmaken',
      update: 'Stickyweb Bedrijf detail',
      list: "Stickyweb Bedrijven list",
    },
    person: {
      create: "Stickyweb Persoon aanmaken",
      update: "Stickyweb Persoon detail",
      list: "Stickyweb Personen lijst",
    },
    dashboard: {
      list: "Stickyweb Dashboard",
      update: "Dashboard",
    },
    invoice: {
      list: "Stickyweb facturatie lijst",
      create: "Stickyweb factuur aanmaken",
      update: "Stickyweb factuur detail",
    }
  },
  crudModeSelect: {
    view: {
      title: "Bekijk indelingen voor"
    },
    create: {
      title: "Indeling aanmaken voor"
    }
  },
  text: {
    title: "Uitleg",
    intro: {
      multi: "Indelingen kunnen aangemaakt worden voor 3 verschillende acties. Het bekijken van de {{module}} lijst, {{module}} detail en voor het aanmaken van een nieuw {{module}}.",
      default: "Het systeem levert een standaard indeling. Je kan een nieuwe indeling voor alle gebruikers, of alleen voor jezelf aanmaken."
    },
    legenda: {
      title: "Legenda",
      userChosen: "De door jou gekozen standaard indeling.",
      widgets: 'Klik hier om widgets aan de indeling toe te voegen, of te verwijderen.',
      rename: "Pas de naam van de indeling aan.",
      delete: "Verwijder een indeling.",
    },
  },
  list: {
    noLayoutInList: "Nog geen eigen indeling aangemaakt",
    newLayout: {
      title: "Nieuwe indeling",
    },
    private: {
      title: 'Privé indelingen',
    },
    client: {
      title: 'Globale indeling',
    },
    global: {
      title: 'Systeem indeling',
    }
  },
  createLayout: {
    buttons: {
      create: "Indeling aanmaken",
      cancel: "Annuleren",
    },
    firstTabName: "Primair",
  },
  createEditLayout: {
    title: "Indeling",
    buttons: {
      addTab: "Tab toevoegen",
      cancel: "Annuleren",
      save: "Opslaan",
      delete: "Delete",
    },
    input: {
      name: {
        label: "Naam",
      },
      private: {
        label: "Privé"
      }
    },
  },
  buttons: {
    switchLayout: "Wissel indeling",
  },

  api: {
    id: {
      notNull: "Onbekende layout",
    },
    name: {
      notNull: "Geef de indeling een naam.",
    },
    tabs: {
      notNull: "Voeg minimaal één tab toe."
    }
  },
}
